<template>
  <div>
    <div class="row row-sm mb-3">
      <div class="col-3">
        <label for="">Employee <span class="text-danger">*</span></label>
        <select v-model="filter.employee_reference" class="form-select" required>
          <option selected value="">--</option>
          <option v-for="(employee, index) in employees" :key="index" :value="employee.reference" :style="employee.blocked || employee.fullName.includes('Bloqué')
            ? { color: 'red' }
            : ''
            ">
            {{ employee.fullName }}
          </option>
        </select>
      </div>

      <div class="col">
        <label for="">Du <span class="text-danger">*</span></label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>
      <div class="col">
        <label for="">Au <span class="text-danger">*</span></label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      <div class="col-auto">
        <label for=""></label>
        <button @click="toFilter(filter)" class="btn btn-secondary">
          <i class="bi bi-funnel"></i> Rechercher
        </button>
      </div>

      <div class="col-auto">
        <label for=""></label>
        <button @click="print(filter)" class="btn btn-secondary">
          <i class="bi bi-printer"></i> Imprimer
        </button>
      </div>
    </div>

    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <div class="col-auto">
          <button @click="refresh()" class="btn btn-secondary me-2">
            <i class="bi bi-arrow-clockwise"></i> Actualiser
          </button>
        </div>
      </div>

      <div class="col-auto">

        <button @click="$router.push({ name: 'transactions-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i> Créer une nouvelle transaction
        </button>
      </div>
    </div>

    <vue-data-table :headers="headers" :data="transactions" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">
      <!-- Employee Column -->
      <template #cell-employee="{ row }">
        <span v-if="row.employee" :class="row.employee.deleted_at
          ? 'text-danger text-decoration-line-through'
          : ''
          ">
          {{ row.employee.fullName }}
        </span>
      </template>

      <template #cell-user="{ row }">
        <span v-if="row.user">
          {{ row.user.name }}
        </span>
      </template>

      <!-- Amount Column -->
      <template #cell-amount="{ row }">
        {{ row.amount | toFixedWithSpace }}
      </template>

      <!-- Transaction Method Column -->
      <template #cell-transactionMethod="{ row }">
        <span class="badge" :class="getMethodBadgeClass(row.transactionMethod)">
          {{ row.transactionMethod }}
        </span>
      </template>




    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0],
        employee_reference: ""
      },
      headers: [
        { field: "reference", label: "Référence", class: "text-left" },
        { field: "employee", label: "Employee", class: "text-left" },
        { field: "date", label: "Date", class: "text-center" },
        { field: "amount", label: "Montant", class: "text-end fw-bold" },
        { field: "transactionMethod", label: "Mode", class: "text-center" },
        { field: "destination", label: "Destination", class: "text-left" },
        { field: "remark", label: "Remarque", class: "text-left" },
        { field: "user", label: "Créer par", class: "text-left" },
      ],
      buttons: [
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
          condition: () => this.$userRole === "Admin"
        },
        {
          label: "Imprimer",
          icon: "bi bi-printer",
          class: "btn-secondary",
          action: (row) => this.print(row.reference),
          condition: () => this.$userRole === "Admin"
        }
      ],
      summableColumns: [
        { field: 'amount', class: 'text-primary' },
      ]
    };
  },
  computed: {
    ...mapGetters("transaction", {
      transactions: "getTransactions",
      totalAmount: "getTotalAmount"
    }),
    ...mapGetters("employee", {
      employees: "getAll"
    }),

  },
  mounted() {
    this.$store.dispatch("transaction/getAll");
    this.$store.dispatch("employee/getAll");
  },
  methods: {

    async refresh() {
      await this.$store.dispatch("transaction/getAll");
    },
    async toFilter(data) {
      await this.$store.dispatch("transaction/filter", data);
    },

    async remove(reference) {
      await this.$store.dispatch("transaction/destroy", reference);
    },

    
    async print(reference) {
      await this.$store.dispatch("transaction/printReceipt", reference);
    },
    

    getMethodBadgeClass(method) {
      const classes = {
        'Espèces': 'bg-success',
        'Chèque': 'bg-primary',
        'Virement': 'bg-info',
        'Carte': 'bg-warning'
      };
      return classes[method] || 'bg-secondary';
    }
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    }
  }
};
</script>

<style scoped>
.text-decoration-line-through {
  text-decoration: line-through;
}
</style>